import { MutateOptions } from "react-query";
import flatten from "lodash/flatten";
import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";

export type getDataType = (
  variables: unknown,
  options?: MutateOptions<any, unknown, unknown, unknown> | undefined
) => void;

export interface SearchCriteriaUnit {
  key: string;
  value: string;
  matchType?: string;
  isEncrypted?: boolean;
}

export interface SearchCriteriaComposite {
  conjugationType: string;
  criterias: Array<SearchCriteriaUnit>;
  isEncrypted?: boolean;
}

export function makeSearchCriteriaUnit(
  criterias: Array<SearchCriteriaUnit> | null,
  conjugationType: string = "OR"
): null | SearchCriteriaUnit | SearchCriteriaComposite {
  if (!criterias) {
    return null;
  }
  if (criterias.length === 0) {
    return null;
  }

  if (criterias.length === 1) {
    return {
      ...criterias[0]
    };
  }

  return {
    conjugationType,
    criterias
  };
}

function getSearchCriteria(...params: Array<SearchCriteriaUnit | SearchCriteriaComposite | null>) {
  const criterias = flatten(params.filter(item => !isEmpty(item)));
  if (criterias.length === 0) {
    return null;
  }

  if (criterias.length === 1) {
    return {
      ...criterias[0]
    };
  }

  return {
    conjugationType: "AND",
    criterias
  };
}

interface CustomType {
  pageIndex: number;
  freeText: string;
  sortInfo: object;
  filters: Array<SearchCriteriaUnit>;
}

export async function fetchMoreData(
  getData: getDataType,
  custom: CustomType,
  ...params: Array<SearchCriteriaUnit | SearchCriteriaComposite | null>
) {
  const { pageIndex, freeText, sortInfo, filters, ...rest } = custom;
  const filtersSearchCriteria = makeSearchCriteriaUnit(filters, "AND");
  getData({
    pageNumber: pageIndex,
    freeText: freeText,
    ...sortInfo,
    ...rest,
    searchCriteria: getSearchCriteria(
      filtersSearchCriteria,
      ...params.filter((o: SearchCriteriaUnit | SearchCriteriaComposite | null) => !o?.isEncrypted)
    ),
    searchCriteriaEncrypted: getSearchCriteria(
      filtersSearchCriteria,
      ...params.filter((o: SearchCriteriaUnit | SearchCriteriaComposite | null) => o?.isEncrypted)
    )
  });
}

export const getMoreDataForTable = debounce(fetchMoreData, 150);
